"use client";
import { translate } from "../../translations/index.js";
const hasLength = (length, characterType = "characters") => (value) => ({
  isValid: value.length === length,
  errorMessage: translate((t) => t.validation.errors.invalidLength(length, t.validation[characterType]))
});
const maxLength = (length, characterType = "characters") => (value) => ({
  isValid: value.length <= length,
  errorMessage: translate((t) => t.validation.errors.invalidMaxLength(length, t.validation[characterType]))
});
const matchesRegex = (regex, errorMessage) => (value) => ({
  isValid: regex.test(value),
  errorMessage
});
export {
  hasLength,
  matchesRegex,
  maxLength
};
